import React from 'react';
import { useTranslation } from 'react-i18next';
import { BarChart2, Users, User as UserIcon, CheckSquare } from 'lucide-react';

const Navigation = ({ activeTab, setActiveTab }) => {
  const { t } = useTranslation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 max-w-md mx-auto bg-[#161224]/95 backdrop-blur-lg border-t border-white/5 p-2 flex justify-around items-center z-40">
      <button
        onClick={() => setActiveTab('trade')}
        className={`flex flex-col items-center gap-1 px-3 py-1.5 rounded-xl transition-all ${
          activeTab === 'trade' ? 'text-purple-400 font-bold' : 'text-gray-500'
        }`}
      >
        <BarChart2 size={20} />
        <span className="text-[10px]">{t('trade')}</span>
      </button>

      <button
        onClick={() => setActiveTab('tasks')}
        className={`flex flex-col items-center gap-1 px-3 py-1.5 rounded-xl transition-all ${
          activeTab === 'tasks' ? 'text-purple-400 font-bold' : 'text-gray-500'
        }`}
      >
        <CheckSquare size={20} />
        <span className="text-[10px]">{t('tasks') || 'Tasks'}</span>
      </button>

      <button
        onClick={() => setActiveTab('referral')}
        className={`flex flex-col items-center gap-1 px-3 py-1.5 rounded-xl transition-all ${
          activeTab === 'referral' ? 'text-purple-400 font-bold' : 'text-gray-500'
        }`}
      >
        <Users size={20} />
        <span className="text-[10px]">{t('referral')}</span>
      </button>

      <button
        onClick={() => setActiveTab('profile')}
        className={`flex flex-col items-center gap-1 px-3 py-1.5 rounded-xl transition-all ${
          activeTab === 'profile' ? 'text-purple-400 font-bold' : 'text-gray-500'
        }`}
      >
        <UserIcon size={20} />
        <span className="text-[10px]">{t('profile')}</span>
      </button>
    </nav>
  );
};

export default Navigation;